import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import BackOfficeNavbar from './components/BackOfficeNavbar';
import backOfficeRoutes from 'routesBackOffice';
import axios from 'axios';
import { CONFIG } from 'variables/config';

export default function BackOfficeLayout() {
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
    const [currentRoute, setCurrentRoute] = useState('Back Office');

    useEffect(() => {
        // Verify admin status
        const verifyAdmin = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/auth/sign-in');
                return;
            }

            try {
                const response = await axios.get(`${CONFIG.apiUrl}/user/me`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                const user = response.data;
                if (user.role === 'admin') {
                    setIsAdmin(true);
                } else {
                    // Not an admin, redirect
                    navigate('/admin');
                }
            } catch (error) {
                console.error('Admin verification failed:', error);
                navigate('/auth/sign-in');
            }
        };

        verifyAdmin();
    }, [navigate]);

    const location = useLocation();

    useEffect(() => {
        const getActiveRoute = () => {
            for (let i = 0; i < backOfficeRoutes.length; i++) {
                const route = backOfficeRoutes[i];
                if (window.location.href.includes(route.layout + route.path)) {
                    setCurrentRoute(route.name);
                    break;
                }
            }
        };
        getActiveRoute();
    }, [location.pathname]);

    const getRoutes = (routes: RoutesType[]): any => {
        return routes.map((prop, key) => {
            if (prop.layout === '/back-office') {
                return (
                    <Route
                        path={`${prop.path}`}
                        element={prop.component}
                        key={key}
                    />
                );
            }
            return null;
        });
    };

    // Show loading state while checking admin status
    if (isAdmin === null) {
        return (
            <div className="flex h-screen w-screen items-center justify-center">
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <div className="flex h-full w-full flex-col">
            <BackOfficeNavbar currentRoute={currentRoute} />
            
            <div className="h-full w-full overflow-auto bg-lightPrimary dark:bg-navy-900">
                <div className="mx-auto min-h-screen p-5 !pt-[100px] md:p-5">
                    <Routes>
                        {getRoutes(backOfficeRoutes)}
                        <Route
                            path="/"
                            element={<Navigate to="/back-office/dashboard" replace />}
                        />
                    </Routes>
                </div>
            </div>
        </div>
    );
}
